import HttpClient from './http-client';
import URL from './url';

export default class TeacherDashboardApi {

    static getClassEngagementList(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.CLASS_ENGAGEMENT_LIST + "?" + params.join('&') : URL.CLASS_ENGAGEMENT_LIST;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

    static getStudentEngagementScoreRanking(payload) {
        let params = [];
        if (payload) {
            Object.keys(payload).forEach(key => {
                params.push(`${key}=${payload[key]}`);
            });
        }
        let paramsList = params.length ? URL.STUDENT_ENGAGEMENT_SCORE_RANKING + "?" + params.join('&') : URL.STUDENT_ENGAGEMENT_SCORE_RANKING;
        return HttpClient.get(URL?.BASE_URL + paramsList, payload);
    }

   

}